<template>
    <v-menu v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            v-bind:disabled="disabled"
            >
        <template v-slot:activator="{on}">
            <v-text-field v-on="on" v-model="dateFormatted"
                          readonly
                          prepend-icon="event"
                          v-bind:label="label"
                          v-bind:disabled="disabled">
            </v-text-field>
        </template>
        <v-date-picker v-model="date" v-on:input="menu = false" v-bind:disabled="disabled" locale="ja-jp"
                       v-bind:type="type"
                       :day-format="date => new Date(date).getDate()"
                       :min="min">

        </v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        props: {
            value: null,
            label: undefined,
            disabled: undefined,
            type: {
                type: String,
                require: false,
                default: 'date'
            },
            min: undefined,
        },
        data: () => ({
            date: null,
            dateFormatted: null,
            menu: false
        }),
        mounted: function () {
            this.$nextTick(function () {
                console.log("mydatepicker.mounted");
                // ビュー全体がレンダリングされた後にのみ実行されるコード
                console.log(this.value);
                if (this.value == null || this.value == "") {
                    if (this.type == 'date') {
                        this.date = new Date().toISOString().substr(0, 10);
                    } else if(this.type == 'month') {
                        this.date = new Date().toISOString().substr(0, 7);
                    }

                    this.dateFormatted = this.formatDate(this.date);
                    this.$emit('input', this.date);

                } else {
                    let val = this.value.toString();

                    if (this.type == 'date') {
                        if (val.length == 8) {
                            this.date = `${val.substr(0, 4)}-${val.substr(4, 2)}-${val.substr(6, 2)}`;
                        } else {
                            this.date = this.value;
                        }
                    } else if (this.type == 'month') {
                        if (val.length == 6) {
                            this.date = `${val.substr(0, 4)}-${val.substr(4, 2)}`;
                        } else {
                            this.date = this.value;
                        }
                    }

                    this.dateFormatted = this.formatDate(this.date);
                    this.$emit('input', this.date);
                }
            })

        },

        watch: {
            value: function (newValue) {
                console.log("mydatepicker.value");
                console.log(newValue);
                if (newValue == "") {

                    if (this.type == 'date') {
                        let v = new Date().toISOString().substr(0, 10);
                        this.value = `${v.substr(0, 4)}${v.substr(5, 2)}${v.substr(8, 2)}`;
                        this.date = `${v.substr(0, 4)}-${v.substr(5, 2)}-${v.substr(8, 2)}`;
                    } else if (this.type == 'month') {
                        let v = new Date().toISOString().substr(0, 7);
                        this.value = `${v.substr(0, 4)}${v.substr(5, 2)}`;
                        this.date = `${v.substr(0, 4)}-${v.substr(5, 2)}`;
                    }

                    return;
                }

                let val = newValue.toString();

                if (this.type == 'date') {
                    if (val.length == 8) {
                        this.date = `${val.substr(0, 4)}-${val.substr(4, 2)}-${val.substr(6, 2)}`;
                        return;
                    }
                } else if (this.type == 'month') {
                    if (val.length == 6) {
                        this.date = `${val.substr(0, 4)}-${val.substr(4, 2)}`;
                        return;
                    }
                }
                this.date = newValue;

            },
            date: function (newValue) {
                console.log("mydatepicker.date");
                console.log(newValue);

                this.dateFormatted = this.formatDate(this.date);
                this.$emit('input', newValue.replace(/-/g, ''));
            }
        },
        methods: {
            formatDate(date) {
                console.log("mydatepicker.formatDate");
                console.log(date);
                if (!date) return null;


                if (this.type == 'date') {
                    if (date.length == 8) {
                        return `${date.substr(0, 4)}/${date.substr(4, 2)}/${date.substr(6, 2)}`;
                    }

                    const [year, month, day] = date.split('-');
                    return `${year}/${month}/${day}`;
                } else if (this.type == 'month') {
                    if (date.length == 6) {
                        return `${date.substr(0, 4)}/${date.substr(4, 2)}`;
                    }


                    const [year, month] = date.split('-');
                    return `${year}/${month}`;
                }

                const [year, month, day] = date.split('-');
                return `${year}/${month}/${day}`;
            }
        },
    }
</script>
<style>
    .v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(7) .v-btn__content {
        color: blue
    }

    .v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(1) .v-btn__content {
        color: red
    }
</style>
